export default "__VITE_ASSET__D$0VPN_f__"